function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import { responseMapper } from "../../helpers/responseMapper";
import { instance } from "../instance";
const getContactsResponseTemplate = {
  code: 'headerResponse.code',
  payload: {
    contacts: ['payload.items', {
      id: '_id',
      username: 'user_name',
      name: 'name',
      eventId: 'event',
      email: 'email',
      position: 'position',
      description: 'description',
      phone: 'phone',
      company: 'company'
    }],
    totalPages: 'payload.pages'
  }
};
export const getContacts = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(function* (_ref) {
    let page = _ref.page,
        searchValue = _ref.searchValue;
    const response = yield instance.post('participant/api-get', {
      name: searchValue,
      page,
      rowsPerPage: 20
    });

    const _responseMapper = responseMapper({
      template: getContactsResponseTemplate,
      data: response.data
    }),
          code = _responseMapper.code,
          payload = _responseMapper.payload;

    return payload;
  });

  return function getContacts(_x) {
    return _ref2.apply(this, arguments);
  };
}();
const getContactInfoTemplate = {
  code: 'headerResponse.code',
  payload: {
    id: 'payload._id',
    username: 'payload.user_name',
    name: 'payload.name',
    avatar: 'payload.avatar',
    eventId: 'payload.event',
    email: 'payload.email',
    position: 'payload.position',
    description: 'payload.description',
    phone: 'payload.phone',
    company: 'payload.company',
    availability: 'payload.availability'
  }
};
export const getContactInfo = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator(function* (contactId) {
    const response = yield instance.post('participant/api-profile', {
      participantId: contactId
    });

    const _responseMapper2 = responseMapper({
      template: getContactInfoTemplate,
      data: response.data
    }),
          code = _responseMapper2.code,
          payload = _responseMapper2.payload;

    if (code !== 200) throw new Error('Ha ocurrido un error al obtener los contactos del evento');
    return payload;
  });

  return function getContactInfo(_x2) {
    return _ref3.apply(this, arguments);
  };
}();